'use client'

import { useGtmOnPageView } from '~/hooks/use-gtm-page-view'

export default function Template({ children }: { children: React.ReactNode }) {
  useGtmOnPageView()

  return <>{children}</>
}
